// app/composables/useModal.js
import { computed } from 'vue'
import { useModalStore } from '../stores/modal'

export default function useModal() {  
  const modalStore = useModalStore()
  
  return {
    // computed properties
    modalOptions: computed(() => modalStore.modalAlertOptions),
    isModalVisible: computed(() => modalStore.isModalVisible),
    modalType: computed(() => modalStore.modalType),
    isEditView: computed(() => modalStore.isEditView),
    customerInfo: computed(() => modalStore.customerInfo),
    
    // methods
    openAlert: modalStore.openModalAlert,
    openConfirm: modalStore.openModalConfirm,
    openPopup: modalStore.openModalPopup,
    openNeedJoin: modalStore.openModalNeedJoin,
    closeModal: modalStore.closeModalAlert,
    confirmModal: modalStore.confirmModal,
    cancelModal: modalStore.cancelModal,
    setEditView: modalStore.setIsEditView,
    setCustomerInfo: modalStore.setCustomerInfo,
  }
}

// 🔧 named export도 함께 제공 (하위 호환성)
export { useModal }